import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CommonForm from "../../../../components/commonform/commonForm";
import CustomIcons from "../../../../components/icons/kIcons.component";
import Loader from "../../../../components/loader/loader";
// import CustomIcons from "../../../../components"
//
import CustomTable from "../../../../components/table/table";
import { download_intern_proposal_file, inter_details } from "../../user.api";

import "./style.css";
import moment from "moment";
export default function Addproposal(props) {
  const selectedParam = useParams();

  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const [data, setData] = useState({});
  const [isActive, setIsActive] = useState(true);
  const getDetails = (id) => {
    inter_details(id).then((res) => {
      let tdata = res.data;

      setData(tdata);
      setIsActive(false);
      console.log(tdata)
    });
  };
  useEffect(() => {
    getDetails(selectedParam.id);
  }, []);
  const handleDownloadResume = (data) => {
    console.log(data)
    let path = `${result}${data}`;
    window.open(path, "_blank");
  };
  // const handleDownloadDocument = async (id) => {
  //   if (!id) {
  //     console.error("User ID is missing for download");
  //     return;
  //   }

  //   try {
  //     const response = await download_intern_proposal_file(id);

  //     if (response) {
  //       // const fileUrl = response.data.file_url;
  //       // console.log("Download URL:", fileUrl);

  //       // Open the file in a new tab
  //       window.open(response, "_blank");
  //     } else {
  //       console.error("File URL not found in API response");
  //     }
  //   } catch (error) {
  //     console.error("Error downloading file:", error);
  //   }
  // };

    const handleDownloadDocument = async (id) => {
  if (!id) {
    console.error("User ID is missing for download");
    return;
  }

  try {
    const response = await download_intern_proposal_file(id);

    // Extract the file URL from the response
    const fileUrl = response?.url;

    if (!fileUrl) {
      console.error("Invalid response: No URL found in API response.");
      return;
    }

    // Open the file in a new tab
    const newTab = window.open(fileUrl, "_blank");

    // Handle cases where the browser blocks pop-ups
    if (!newTab) {
      alert("Popup blocked! Please allow popups for this site.");
    }
  } catch (error) {
    console.error("Error downloading file:", error);
  }
    };
    const handleDownload = (dt) => {
      let path = `${result}${dt.certificate_photo}`;
      window.open(path, "_blank");
    };
  
  return (
    <div className="proj">
      {/* <CustomIcons iconName="phone1" iconClass="daticon" /> */}
      <Loader open={isActive} />
      {/* <img src="../public/resources/pdf.png" alt="" /> */}
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">Internship / Training Detail</div>
        </div>
      </div>
      <div className="container deta mt-3">
        <div className="row">
          {/* --------------------- */}
          <div className="col-md-9 col-sm-12 detail-pad mb-3 deta1">
            <div className="row">
              <center>
                <div className="col-6">
                  <img
                    src={`${result}${data?.file_upload_photo}`}
                    className="pic2 mb-2"
                    alt=""
                  />
                </div>
                <div className="col-11 mt-3 gray">
                  <div className="row">
                    <div className="col-3">Name</div>
                    <div className="col-1">:</div>
                    <div className="col-8">{data.full_name}</div>
                  </div>
                </div>
                <div className="col-11 mt-3 gray">
                  <div className="row">
                    <div className="col-3">Date of Birth</div>
                    <div className="col-1">:</div>
                    <div className="col-8">
                      {data.date_of_birth &&
                        moment(data.date_of_birth).format("DD-MM-YYYY")}
                    </div>
                  </div>
                </div>
                <div className="col-11 mt-3 gray">
                  <div className="row">
                    <div className="col-3">Gender</div>
                    <div className="col-1">:</div>
                    <div className="col-8">{data.gender}</div>
                  </div>
                </div>
                <div className="col-11 mt-3 gray">
                  <div className="row">
                    <div className="col-3">Institution</div>
                    <div className="col-1">:</div>
                    <div className="col-8">
                      {data?.institution?.[0]?.institution_name ?? ""}
                    </div>
                  </div>
                </div>
                <div className="col-11 mt-3 gray">
                  <div className="row">
                    <div className="col-3">Address</div>
                    <div className="col-1">:</div>
                    <div className="col-8">{data.address}</div>
                  </div>
                </div>
                <div className="col-11 mt-3 gray">
                  <div className="row">
                    <div className="col-3">Resume</div>
                    <div className="col-1">:</div>
                    {/* <div className="col-8">{data.address}</div> */}
                    <div
                      className=" col-8 text-primary"
                      style={{ cursor: "pointer" }}
                      onClick={(e) =>
                        handleDownloadResume(data?.resume)
                      }
                    >
                      Download Resume
                    </div>

                  </div>
                </div>

                {/* <div className="col-11 mt-3 gray">
                  <div className="row">
                    <div className="col-3">Email</div>
                    <div className="col-1">:</div>
                    <div className="col-8">Akhil Krishnan k</div>
                  </div>
                </div>
                <div className="col-11 mt-3 gray">
                  <div className="row">
                    <div className="col-3">Phone Number</div>
                    <div className="col-1">:</div>
                    <div className="col-8">Akhil Krishnan k</div>
                  </div>
                </div> */}
                <div className="col-11 mt-3 gray">
                  <div className="row ">
                    <div className="col-3 mt-2">Educational Qualification</div>

                    <div className="col-12 edux ">
                      <CustomTable
                        {...props}
                        columns={[
                          {
                            title: " Examination Passed",
                            field: "exam_passed",
                          },
                          { title: "Board", field: "board" },
                          { title: "Year of Passing", field: "year_passed" },
                          { title: "Mark", field: "mark" },
                          { title: "Certificate", field: "certificate_photo",type: "download" },

                        ]}
                        data={data.intern_qualification ?? []}
                        handleDownload={handleDownload}

                      />
                    </div>
                  </div>
                </div>
                <div className="col-11 mt-3 gray">
                  <div className="row">
                    <div className="col-3">Languages Known</div>
                    <div className="col-1">:</div>
                    <div className="col-8">
                      {data.intern_languages &&
                        data.intern_languages.length !== 0 &&
                        data.intern_languages.map((lang, i) => (
                          <>
                            {i > 0 && <sapn>&nbsp;|&nbsp;</sapn>}
                            <span>{lang.language}</span>
                          </>
                        ))}
                    </div>
                  </div>
                </div>
                <div className=" flex align-center mt-4">
                  <button
                    className="btn btn-approve btn-success"
                    onClick={(e) =>
                      handleDownloadDocument(
                        data.id
                      )
                    }
                  >
                    Download Documents
                  </button>
                </div>



              </center>
            </div>
          </div>

          {/* ---end card----- */}
          <div className="footer-buttons">
            <button
              onClick={(e) => props.history.push("/training-list")}
              className="primary-btn "
            >
              Back to Directory
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
